module.exports = __webpack_public_path__ + "static/media/img11.68c2ed8b.jpg";